import { render, staticRenderFns } from "./CalendarHeader.vue?vue&type=template&id=1295008c&"
import script from "./CalendarHeader.vue?vue&type=script&lang=js&"
export * from "./CalendarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports